import React from "react";
import { Button } from "@/components/ui/button";
import { Wallet, CheckCircle, XCircle, Loader2 } from "lucide-react";

export function WithdrawalsTab({ withdrawals, processingWithdrawal, onAction }) {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold">Withdrawal Requests</h2>
      
      {withdrawals.length === 0 ? (
        <div className="text-center py-10 border border-border">
          <Wallet className="w-12 h-12 mx-auto text-muted-foreground/30 mb-4" />
          <p className="text-muted-foreground">No withdrawal requests</p>
        </div>
      ) : (
        <div className="space-y-3">
          {withdrawals.map((withdrawal) => (
            <WithdrawalCard
              key={withdrawal.withdrawal_id}
              withdrawal={withdrawal}
              processing={processingWithdrawal === withdrawal.withdrawal_id}
              onAction={onAction}
            />
          ))}
        </div>
      )}
    </div>
  );
}

function WithdrawalCard({ withdrawal, processing, onAction }) {
  const getStatusColor = (status) => {
    switch (status) {
      case 'completed': return 'bg-green-100 text-green-800';
      case 'approved': return 'bg-blue-100 text-blue-800';
      case 'rejected': return 'bg-red-100 text-red-800';
      default: return 'bg-yellow-100 text-yellow-800';
    }
  };

  return (
    <div className="border border-border p-4">
      <div className="flex items-center justify-between">
        <div>
          <p className="font-bold">₹{withdrawal.amount.toFixed(2)}</p>
          <p className="text-sm text-muted-foreground">
            Partner: {withdrawal.partner_name || withdrawal.partner_id}
          </p>
          <p className="text-xs text-muted-foreground">
            {new Date(withdrawal.created_at).toLocaleDateString()}
          </p>
        </div>
        <div className="flex items-center gap-3">
          <span className={`px-3 py-1 text-xs font-bold uppercase ${getStatusColor(withdrawal.status)}`}>
            {withdrawal.status}
          </span>
          
          {withdrawal.status === 'pending' && (
            <>
              <Button
                size="sm"
                onClick={() => onAction(withdrawal.withdrawal_id, 'approve')}
                disabled={processing}
                className="rounded-none bg-green-600 hover:bg-green-700"
                data-testid={`approve-withdrawal-${withdrawal.withdrawal_id}`}
              >
                {processing ? (
                  <Loader2 className="w-4 h-4 animate-spin" />
                ) : (
                  <CheckCircle className="w-4 h-4" />
                )}
              </Button>
              <Button
                size="sm"
                variant="destructive"
                onClick={() => onAction(withdrawal.withdrawal_id, 'reject')}
                disabled={processing}
                className="rounded-none"
                data-testid={`reject-withdrawal-${withdrawal.withdrawal_id}`}
              >
                <XCircle className="w-4 h-4" />
              </Button>
            </>
          )}
          
          {withdrawal.status === 'approved' && (
            <Button
              size="sm"
              onClick={() => onAction(withdrawal.withdrawal_id, 'complete')}
              disabled={processing}
              className="rounded-none"
              data-testid={`complete-withdrawal-${withdrawal.withdrawal_id}`}
            >
              Mark Complete
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
